var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Space, Dropdown } from 'antd';
import { BLUE } from 'ui/constants';
import { Button } from 'ui/styled';
import { merge } from 'components/DynamicFiltersBar/helpers';
var DynamicFiltersBar = function (_a) {
    var _b = _a.resetFilters, resetFilters = _b === void 0 ? function () { } : _b, _c = _a.elements, elements = _c === void 0 ? {} : _c, _d = _a.filterValues, filterValues = _d === void 0 ? {} : _d, _e = _a.defaultActiveKeys, defaultActiveKeys = _e === void 0 ? [] : _e;
    var elementsKeys = Object.keys(elements);
    var filterKeys = Object.keys(filterValues);
    var _f = useState([]), activeElements = _f[0], setActiveElements = _f[1];
    var _g = useState(defaultActiveKeys), activeKeys = _g[0], setActiveKeys = _g[1];
    var onEnableElement = function (e) {
        var key = e.key;
        if (!key)
            return false;
        setActiveElements(__spreadArray(__spreadArray([], activeElements, true), [elements[key].element], false));
        setActiveKeys(__spreadArray(__spreadArray([], activeKeys, true), [key], false));
    };
    useEffect(function () {
        if (!elements || elementsKeys.length === 0)
            return;
        if (filterValues) {
            // State over props to not reset active elements on filters change
            var keys = merge(activeKeys, filterKeys);
            var applicableFilters = keys.filter(function (i) { return elementsKeys.includes(i); });
            setActiveElements(applicableFilters.map(function (i) { return (__assign(__assign({}, elements[i].element), { key: i })); }));
            setActiveKeys(applicableFilters);
        }
        // eslint-disable-next-line
    }, [JSON.stringify(filterValues), elements]);
    var items = elementsKeys
        .filter(function (i) { return !activeKeys.includes(i); })
        .map(function (i) { return ({
        key: i,
        value: i,
        label: elements[i].name
    }); });
    return (_jsxs(Space, { wrap: true, children: [activeElements, items.length > 0 && (_jsx(Dropdown, { menu: { items: items, onClick: onEnableElement }, trigger: ['click'], children: _jsx(Button, { btntype: "custom", color: BLUE, bgcolor: "transparent", border: "none", bxshadow: "none", "data-test": "addFilterButton", children: "+ Add filter" }) })), filterKeys.length > 0 && (_jsx(Button, { onClick: resetFilters, btntype: "custom", color: BLUE, bgcolor: "transparent", border: "none", bxshadow: "none", "data-test": "resetFiltersButton", children: "Reset filters" }))] }));
};
export default DynamicFiltersBar;
